import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { fetchMainmenu, fetchFootermenu } from './../actions';
import { fetchFooterStaticText, fetchFeeds } from './../../ui/src/actions.js';
import { Header } from './../component/header';
import { Loader } from '../../ui/src/component/loader';
import Banner from '../component/banner';
import SweetAlert from 'sweetalert-react';
import { Helmet } from 'react-helmet';
import HeaderPanel from '../../ui/src/component/headerPanel';

import { getProp } from '../../ui/src/utilities';
// Moment locale initialisation
import 'moment/locale/sk';
import CookieConsent from '../component/cookies/cookieConsent';
import Footer from '../component/footer/footer';

class App extends React.Component {
  constructor(props) {
    super(props);

    const feeds = [];
    const feedsObj = getProp(this.props, 'feeds', {});
    for (const k in feedsObj) {
      feeds.push(feedsObj[k]);
    }

    this.state = {
      searchQuery: getProp(this.props, 'location.query.q', ''),
      currentFeed: feeds.length > 0 ? feeds[0] : null,
    };

    this.feedChangeInterval = null;
    this.changeFeed = this.changeFeed.bind(this);
  }

  static init(dispatch) {
    return Promise.all([
      dispatch(fetchMainmenu()),
      dispatch(fetchFootermenu()),
      dispatch(fetchFeeds()),
      dispatch(
        fetchFooterStaticText(
          process.env.REACT_APP_CONTENT_SPACE,
          'text-v-pate-stranky',
        ),
      ),
    ]);
  }

  componentDidMount() {
    App.init(this.props.dispatch);
    this.feedChangeInterval = setInterval(this.changeFeed, 10000);
  }

  changeFeed() {
    const { currentFeed } = this.state;
    const feeds = Object.values(this.props.feeds);

    let nextFeed = null;
    if (currentFeed !== null) {
      for (let i = 0; i < feeds.length; i++) {
        if (currentFeed._id === feeds[i]._id) {
          if (i + 1 === feeds.length) {
            nextFeed = feeds[0];
            break;
          } else {
            nextFeed = feeds[i + 1];
            break;
          }
        }
      }
    } else {
      nextFeed = feeds[0];
    }

    this.setState({
      currentFeed: nextFeed,
    });
  }

  onSubmitSearch() {
    let q = this.state.searchQuery.trim();
    if (q.length > 0) {
      this.props.dispatch(push(`/vyhladavanie?q=${q}`));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (typeof window.addthis !== 'undefined') {
      getProp(window.addthis, 'layers.refresh', () => {})();
    }
  }

  componentWillUnmount() {
    clearInterval(this.feedChangeInterval);
  }

  componentDidUpdate(prevProps) {
    if (
      Object.keys(this.props.feeds).length > 0 &&
      Object.keys(prevProps.feeds).length === 0
    ) {
      this.changeFeed();
    }
  }

  render() {
    const date = new Date();
    return (
      <div>
        <Helmet title="Hlavná stránka" titleTemplate="%s | Rádio Košice" />
        <CookieConsent />
        <Loader loading={this.props.loading} />
        <HeaderPanel feed={this.state.currentFeed} />
        <div>
          <div className="container">
            <Banner
              id="banner-radiokosice-sk-uplne-na-vrchu"
              autoReload={true}
              location={this.props.location}
            />
          </div>
        </div>
        <Header
          nav={this.props.mainmenu}
          searchQuery={this.state.searchQuery}
          onChangeSearchQuery={(searchQuery) => this.setState({ searchQuery })}
          onSubmitSearch={this.onSubmitSearch.bind(this)}
        />
        <div>
          <div className="container">
            <Banner
              id="banner-radiokosice-sk-medzi-menu-a-obsah-stranky"
              location={this.props.location}
            />
          </div>
        </div>
        <div>
          <div>{this.props.children}</div>
          <SweetAlert
            title=""
            {...this.props.alert}
            show={this.props.alert !== null}
          />
        </div>
        <Footer
          nav={this.props.footermenu}
          content={this.props.footerStaticText}
          copyrightText={`2007-${date.getFullYear()} © MARK MEDIA s.r.o.`}
          facebookUrl="https://www.facebook.com/RadioKosice/"
        />
      </div>
    );
  }
}

App.propTypes = {
  alert: PropTypes.object,
  loading: PropTypes.number.isRequired,
  mainmenu: PropTypes.array.isRequired,
  footermenu: PropTypes.array.isRequired,
  children: PropTypes.node.isRequired,
  dispatch: PropTypes.func.isRequired,
  footerStaticText: PropTypes.object,
};

App.fetchData = ({ store }) => {
  App.init(store.dispatch);
};

App.__name = 'App';

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => {
  return {
    alert: state.alert,
    loading: state.loading,
    mainmenu: state.mainmenu.data.sections,
    footermenu: state.footermenu.data.sections,
    footerStaticText: state.footerStaticText.data.content,
    feeds: state.feeds.byId,
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/app/container/app.js